import React, { Component } from "react";
import { Paper, Typography, Select, MenuItem } from "@material-ui/core";

export default class JobPackSelectReports extends Component {
    constructor(props) {
        super(props);
        this.state = { profile: props.profile, edit: props.edit };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderDropDown = (key, label) => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div style={{ display: "flex" }} key={key}>
                    <Typography
                        style={{ marginRight: 20, marginTop: 10 }}
                        variant="body1"
                    >
                        <b>{label}:</b>
                    </Typography>
                    <Select
                        style={{ width: 150 }}
                        value={profile[key] ? profile[key] : "Yes"}
                        onChange={event => {
                            this.props.callback(key, event.target.value);
                        }}
                    >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                    </Select>
                </div>
            );
        } else
            return (
                <div style={{ display: "flex" }}>
                    <Typography style={{ marginRight: 40 }} variant="body1">
                        <b>{label}:</b>
                    </Typography>
                    <Typography variant="body1">
                        {profile[key] ? profile[key] : "N/A"}
                    </Typography>
                </div>
            );
    };
    renderSSWPOptions = () => {
        const { profile } = this.state;
        const { sswpConfigs } = this.props;
        let sswpConfigName = "Default";
        sswpConfigs.map(e => {
            if (e.uid === profile.sswp_config_uid) {
                sswpConfigName = e.name;
            }
            return null;
        });
        if (this.state.edit) {
            return (
                <React.Fragment>
                    <div style={{ display: "flex" }}>
                        <Typography
                            style={{ marginRight: 20, marginTop: 10 }}
                            variant="body1"
                        >
                            <b>SSWP:</b>
                        </Typography>
                        <Select
                            style={{ width: 150 }}
                            value={
                                profile.master_sswp_v1
                                    ? profile.master_sswp_v1
                                    : "Yes"
                            }
                            onChange={event => {
                                this.props.callback(
                                    "master_sswp_v1",
                                    event.target.value
                                );
                            }}
                        >
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                        </Select>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Typography
                            style={{ marginRight: 20, marginTop: 10 }}
                            variant="body1"
                        >
                            <b>SSWP Config:</b>
                        </Typography>
                        <Select
                            style={{ width: 150 }}
                            value={profile.sswp_config_uid}
                            onChange={event => {
                                this.props.callback(
                                    "sswp_config_uid",
                                    event.target.value
                                );
                            }}
                        >
                            <MenuItem value="">Default</MenuItem>
                            {sswpConfigs.map(e => {
                                return (
                                    <MenuItem key={e.uid} value={e.uid}>
                                        {e.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div style={{ display: "flex" }}>
                        <Typography style={{ marginRight: 40 }} variant="body1">
                            <b>SSWP:</b>
                        </Typography>
                        <Typography variant="body1">
                            {profile.master_sswp_v1
                                ? profile.master_sswp_v1
                                : "N/A"}
                        </Typography>
                    </div>
                    <div style={{ display: "flex" }}>
                        <Typography style={{ marginRight: 40 }} variant="body1">
                            <b>SSWP Config:</b>
                        </Typography>
                        <Typography variant="body1">
                            {sswpConfigName}
                        </Typography>
                    </div>
                </React.Fragment>
            );
        }
    };
    render() {
        const { reportTypes } = this.props;
        return (
            <Paper
                style={{
                    padding: 20,
                    textAlign: "center"
                }}
            >
                <Typography style={{ marginBottom: 30 }} variant="h5">
                    Select Reports For Jobpack
                </Typography>
                <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    {reportTypes &&
                        Object.keys(reportTypes).map(e => {
                            if (e !== "master_sswp_v1") {
                                return this.renderDropDown(e, reportTypes[e]);
                            } else return null;
                        })}
                    {this.props.sswpConfigs && this.renderSSWPOptions()}
                </div>
            </Paper>
        );
    }
}
